import { createStore, type ReadableStore } from './store';

export interface ConnectivitySnapshot {
  online: boolean;
  /** Epoch ms of the last change (or of creation). */
  since: number;
}

export interface Connectivity extends ReadableStore<ConnectivitySnapshot> {
  dispose(): void;
}

/** Online/offline from `navigator.onLine` and the window events. */
export function createConnectivity(): Connectivity {
  const initial = typeof navigator === 'undefined' ? true : navigator.onLine;
  const store = createStore<ConnectivitySnapshot>({ online: initial, since: Date.now() });
  const set = (online: boolean) => () => {
    if (store.getSnapshot().online !== online) store.set({ online, since: Date.now() });
  };
  const goOnline = set(true);
  const goOffline = set(false);
  if (typeof window !== 'undefined') {
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
  }
  return {
    subscribe: store.subscribe,
    getSnapshot: store.getSnapshot,
    dispose() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('online', goOnline);
        window.removeEventListener('offline', goOffline);
      }
    },
  };
}
